export function makePayment({
  orderId,
  referenceId,
  successFunc,
  errorFunc = (error) => console.error("Payment error:", error),
  closeFunc = () => {},
}) {
  // Check if Remita payment engine is available
  if (!window.RmPaymentEngine) {
    errorFunc("Payment system is not available. Please try again later.");
    console.error("Remita Payment Engine is not loaded");
    return;
  }

  try {
    const paymentEngine = window.RmPaymentEngine.init({
      key: "QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY=",
      processRrr: true,
      transactionId: orderId,
      channel: "CARD,USSD",
      extendedData: {
        customFields: [
          {
            name: "rrr",
            value: referenceId,
          },
        ],
      },
      onSuccess: function (response) {
        successFunc(response?.paymentReference);
      },
      onError: function (response) {
        errorFunc(response?.message || "Payment failed");
      },
      onClose: function () {
        closeFunc();
      },
    });

    paymentEngine.showPaymentWidget();
  } catch (error) {
    errorFunc("Error initializing payment. Please try again.");
    console.error("Payment initialization error:", error);
  }
}
